<template>
    <v-pagination
        v-if="!isLessThan480"
        color="#fff"
        class="custom-pagination"
		:total-visible="10"
		v-model="currentPage"
		:length="pageCount"
    />
    <div class="mobile-pagination" v-else>
        <v-btn
            :class="{
                'mobile-pagination__button elevation-0': true,
                'mobile-pagination__button-disabled': decreasePageDisabled
            }" 
            @click="decreasePage" 
            
        >
            <v-icon>
                mdi-chevron-left
            </v-icon>
        </v-btn>
        <div class="mobile-pagination__select-wrapper">
            <input
                v-model="selectPage" 
                type="number"
                class="mobile-pagination__select"
                @blur="handleBlur"
            />
            <span class="ml-2">
                Of
            </span>
            <span class="ml-1 font-weight-bold">
                {{ pageCount }}
            </span>
        </div>
        <v-btn
            :class="{
                'mobile-pagination__button elevation-0': true,
                'mobile-pagination__button-disabled':increasePageDisabled
            }"  
            @click="increasePage"
        >
            <v-icon>
                mdi-chevron-right
            </v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        page: {
            type: Number,
            default: 0
        },
        pageCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            selectPage: 0
        }
    },
    methods: {
        handleBlur() {
            if (this.selectPage && this.selectPage > 0 && this.selectPage <= this.pageCount) {
                if (this.selectPage !== this.page) {
                    this.$emit('pageChange', +this.selectPage)
                }
            } else {
                this.selectPage = this.page
            }
        },
        decreasePage() {
            if (!this.decreasePageDisabled) {
                this.$emit('pageChange', this.selectPage - 1)
            }
        },
        increasePage() {
            if (!this.increasePageDisabled) {
                this.$emit('pageChange', this.selectPage + 1)
            }
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(value) {
               this.$emit('pageChange', value)
            }
        },
        isLessThan480() {
            return this.$vuetify.breakpoint.width <= 480
        },
        decreasePageDisabled() {
            return this.selectPage === 1
        },
        increasePageDisabled () {
            return this.selectPage === this.pageCount
        }
    },
    watch: {
        isLessThan480: {
            handler(newValue) {
                    if (newValue) {
                        this.selectPage = this.page
                    }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss">
.custom-pagination {
    .v-pagination {
        &__navigation {
            display: none;
        }
        &__item {
            color: var(--accent-color) !important;
            box-shadow: none;
            font-size: 15px;
            font-weight: 600;

            &--active {
                color: #fff !important;
                background-color: var(--accent-color) !important;
            }
        }
        &__more {
            color: var(--accent-color);
        }
    }
}
.mobile-pagination {
    width: 70%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    color: var(--accent-color);

    &__select {
        width: 50px !important;
        text-align: center;
        outline: none;
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid #A9A9A9;
        height: 20px;

        &-wrapper {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
        }
    }

    &__button {
        background-color: transparent !important;

        i {
            color: var(--button-main-background-color) !important;
        }
        &-disabled {
            i {
                 color: #A9A9A9 !important;
            }
        }
    }
}
</style>